import { useEffect, useState } from "react";

const KEY = "fd:customerView";

function read(): boolean {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(KEY) === "1";
}

const listeners = new Set<(v: boolean) => void>();

export function setCustomerView(active: boolean) {
  if (typeof window === "undefined") return;
  if (active) sessionStorage.setItem(KEY, "1");
  else sessionStorage.removeItem(KEY);
  listeners.forEach((l) => l(active));
}

export function useCustomerView() {
  const [active, setActive] = useState<boolean>(() => read());
  useEffect(() => {
    const l = (v: boolean) => setActive(v);
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return { active, setActive: setCustomerView } as const;
}
